import { useState } from 'react'
import { 
  MapPin, 
  Star, 
  ArrowBigUpDash, 
  MonitorStop, 
  Clock, 
  Quote, 
  Network 
} from 'lucide-react'
import { FilterPanel, type Filters as TimelineFilters } from '@/components/FilterPanel'
import { SidebarActions } from '@/components/SidebarActions'

interface TimelineSidebarProps {
  onFiltersChange?: (_filters: TimelineFilters) => void
  currentFilters?: TimelineFilters
  isFiltersPanelOpen?: boolean
  onFiltersPanelChange?: (_isOpen: boolean) => void
}

export function TimelineSidebar({ onFiltersChange, isFiltersPanelOpen: externalIsOpen, onFiltersPanelChange }: TimelineSidebarProps) {
  const [internalIsOpen, setInternalIsOpen] = useState(false)
  const isFiltersPanelOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen
  const setIsFiltersPanelOpen = onFiltersPanelChange || setInternalIsOpen

  const sidebarItems = [
    { icon: MapPin, label: 'Território' },
    { icon: Star, label: 'Favoritos' },
    { icon: ArrowBigUpDash, label: 'Upload' },
    { icon: MonitorStop, label: 'Monitor' },
    { icon: Clock, label: 'Histórico' },
    { icon: Quote, label: 'Citações' },
    { icon: Network, label: 'Hierarquia' }
  ]

  const handleFiltersApply = (filters: TimelineFilters) => {
    onFiltersChange?.(filters)
  }

  return (
    <div className="flex self-start sticky top-20">
      <FilterPanel
        isOpen={isFiltersPanelOpen}
        onClose={() => setIsFiltersPanelOpen(false)}
        onApply={handleFiltersApply}
      />
      <SidebarActions
        onToggleFilters={() => setIsFiltersPanelOpen(!isFiltersPanelOpen)}
        items={sidebarItems}
      />
    </div>
  )
}
